import { fork } from 'redux-saga/effects';
import browserHistory from 'history/browser';
import { router } from '@onegini/redux-saga-router';

import analyticsService from '../../common/Services/AnalyticsService';
import { routeDefinitions } from '../../common/routing';

const ROOT_ROUTE = '';

const configureAnalyticsRoute = (path, area) => ({ path: `${ROOT_ROUTE}/${path}`, area });

const trackedRoutes = routeDefinitions.map(([path, area]) => configureAnalyticsRoute(path, area));

const generateRoutes = (routes, analyticsService, browserHistory) =>
  routes.reduce((acc, route) => {
    acc[route.path] = function* (params = {}) {
      const segments = typeof route.area === 'function' ? route.area(params) : route.area;

      analyticsService.trackPage({
        type:             analyticsService.trackingTypes.ROUTE,
        route:            browserHistory.location.pathname,
        pageNameSegments: segments,
      });
    };
    return acc;
  }, {});

const routeHandlers = generateRoutes(trackedRoutes, analyticsService, browserHistory);

// for now this will ensure we bootstrap the app on each route
const options = {
  matchAll: false,
  *beforeRouteChange() {
    // you could just track all pages here...
    // analyticsService.trackPage({
    //   type:    analyticsService.trackingTypes.ROUTE,
    //   route:   browserHistory.getCurrentLocation(),
    //   message: 'tracking a route',
    // });
  },
};

export default function* analyticsSaga() {
  // register router saga
  yield fork(router, browserHistory, routeHandlers, options);
}
